import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
// Styles
import styles from './InfoTip.module.scss';

type InfoTipProps = {
  title: React.ReactNode;
};

/** Help icon that sits on the text line of its label, unlike the superscript Tip */
const InfoTip = ({ title }: InfoTipProps): JSX.Element => (
  <Tooltip title={title}>
    <span className={styles.icon} role="img" aria-label="More info">
      <QuestionCircleOutlined />
    </span>
  </Tooltip>
);

export default InfoTip;
